import BaseAPI from './base'
/**
 * API xử lý học sinh
 */
class ExerciseAPI extends BaseAPI {}

export default new ExerciseAPI('v1/student-exercises', 'Exercise')
